<div class="advice-build-up nes-rounded-container nes-mt-12 nes-p-5">
  <div
    class="flex-containernes nes-flex nes-flex-col-reverse lg:nes-flex-row nes-justify-between nes-items-center"
  >
    <div class="nes-w-full lg:nes-w-6/12">
      <app-receipt [isAdvicePage]="true"></app-receipt>
    </div>
    <div class="nes-w-full lg:nes-w-4/12 nes-mb-10">
      <h4 class="nes-mb-5 nes-text-inverse-subdued nes-text-800 nes-font-bold">
        {{ "ADVICE.ADVICE_BUILD_UP.HEADER" | translate }}
      </h4>
      <p class="nes-mb-5 nes-text-inverse-subdued">
        {{ "ADVICE.ADVICE_BUILD_UP.TEXT" | translate }}
      </p>
      <nes-button inverted variant="primary" (nesOnClick)="requestContact.emit()">{{
        "ADVICE.ADVICE_BUILD_UP.BUTTON_TEXT" | translate
      }}</nes-button>
    </div>
  </div>
</div>
